import React, { FC, memo } from 'react';
import { DisciplineRouteType } from '@om-fe/core/components/discipline-anchor/discipline-route.utils';
import { useLang } from '@om-fe/widgets/dist/common/i18n/i18n.hooks';
import { DisciplineBreadcrumbs } from './discipline-breadcrumbs';
import { breadcrumbsBem } from './breadcrumbs.constants';
import { FlagIcon, FlagIconLocations } from '@om-fe/widgets/dist/components/icon/flag-icon';
import { DisciplineIcon } from '@om-fe/widgets/dist/components/icon/discipline-icon';
import BackButton from '../back-button/back-button';

interface BreadcrumbsPublicProps {
    readonly isLarge?: boolean;
    readonly disciplineId: string;
    readonly locationId?: string;
    readonly tournamentId?: string;
    readonly eventId?: string;
    readonly routeType: DisciplineRouteType;
    readonly categoryId?: string;
    readonly sportChildId?: string;
    readonly isLive?: boolean;
}

export type BreadcrumbsProps = BreadcrumbsPublicProps;

export const Breadcrumbs: FC<BreadcrumbsProps> = memo(function BreadcrumbsComponent(
    {
        isLarge,
        routeType,
        disciplineId,
        locationId,
        tournamentId,
        eventId,
        categoryId,
        sportChildId,
        isLive = false,
    }: BreadcrumbsProps
) {
    const lang: string = useLang();
    const showIcon: boolean = true;
    const flagLocationId: string | undefined = locationId === '0' ? FlagIconLocations.World : locationId;

    return (
        <div className={breadcrumbsBem()}>
            <BackButton isLarge={isLarge} className={breadcrumbsBem('BackButton')}/>
            {showIcon && (
                <div className={breadcrumbsBem('Flags')}>
                    <DisciplineIcon disciplineId={disciplineId} />
                    {flagLocationId && <FlagIcon locationId={flagLocationId} />}
                    </div>
            )
            }
            {
                disciplineId && (
                    <DisciplineBreadcrumbs
                        disciplineId={disciplineId}
                        locationId={locationId}
                        routeType={routeType}
                        isLarge={isLarge}
                        tournamentId={tournamentId}
                        lang={lang}
                        eventId={eventId}
                        categoryId={categoryId}
                        sportChildId={sportChildId}
                        isLive={isLive}
                    />
                )
            }
        </div>
    );
});
